import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import MoreVert from 'material-ui/svg-icons/navigation/more-vert';

const HistoryGridMenuOptions = ({ onDownloadOriginal, onDownloadError, downloadErrorDisabled }) => (
  <IconMenu
    iconButtonElement={ <IconButton><MoreVert /></IconButton> }
    anchorOrigin={ {horizontal: 'right', vertical: 'top'} }
    targetOrigin={ {horizontal: 'right', vertical: 'top'} }
  >
    <MenuItem primaryText="Download original file" onClick={ onDownloadOriginal } />
    { !downloadErrorDisabled && <MenuItem primaryText="Download file with errors" onClick={ onDownloadError } /> }
  </IconMenu>
);

HistoryGridMenuOptions.propTypes = {
  onDownloadOriginal: PropTypes.func,
  onDownloadError: PropTypes.func,
  downloadErrorDisabled: PropTypes.bool
};

HistoryGridMenuOptions.defaultProps = {
  onDownloadOriginal: () => null,
  onDownloadError: () => null,
  downloadErrorDisabled: true
};

export default HistoryGridMenuOptions;



// WEBPACK FOOTER //
// ./src/components/importData/comp/selectImportProfilePanel/comp/importHistoryGrid/comp/historyGridMenuOptions/HistoryGridMenuOptions.js